import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@zoom/react-ui'
import { updateQuery, updateRecommendation } from './actions'
import { selectRecommendation } from './reducer'
import { logSuggestionSelected } from '../telemetry/telemetry'
import { useTranslation } from 'react-i18next'
import './Recommendation.css'

const Recommendation = ({ recommendation, index, total = 3 }) => {
  const dispatch = useDispatch()
  const selectedRecommendation = useSelector(selectRecommendation)
  const { t, i18n } = useTranslation()
  const isSelected = selectedRecommendation === recommendation

  const handleClick = () => {
    if (isSelected) {
      dispatch(updateRecommendation(null))
      dispatch(updateQuery(null))
    } else {
      dispatch(updateRecommendation(t(recommendation)))
      dispatch(updateQuery(t(recommendation) + ' '))
      // Log telemetry when a suggestion is selected
      logSuggestionSelected()
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault()
      const nextIndex =
        event.key === 'ArrowRight'
          ? (index + 1) % total
          : (index - 1 + total) % total
      document.getElementById(`recommendation-${nextIndex}`)?.focus()
    }
    // Note: Enter/Space keys will trigger onClick, so telemetry is logged there
  }

  return (
    <Button
      type="secondary"
      id={`recommendation-${index}`}
      aria-label={`${recommendation}, ${
        isSelected ? 'selected' : 'not selected'
      }, ${index + 1} of ${total}`}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`${
        selectedRecommendation === recommendation ? 'selected' : ''
      } Recommendation ${
        i18n.language === 'ja' || i18n.language === 'ru' ? 'sm' : ''
      }`}
      key={recommendation}
    >
      {t(recommendation)}
    </Button>
  )
}

export default Recommendation
